











import {Component, Vue, Prop} from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';


@Component({components: {apexchart: VueApexCharts}})
export default class ConsumptionsDistributionChart extends Vue {
  @Prop({required: true})
  series: { unit: string, data: { labels: [], values: [] } };

  @Prop({default: false})
  loadingData: boolean;

  @Prop({required: true})
  isListDisplay: boolean;

  get options(): ApexCharts.ApexOptions {
    return {
      labels: this.series.data.labels,
      chart: {
        type: 'pie',
        zoom: {
          enabled: false
        }
      },
      noData: {
        text: 'Aucune donnée',
      },
      legend: {
        position: this.isListDisplay ? 'right' : 'bottom',
      },
      fill: {
        type: 'solid',
      },
      markers: {
        size: 5,
      },
      yaxis: {
        labels: {
          formatter: (val) => {
            if(val < 0.1){
              return `${val.toFixed(4)} ${this.series.unit}`;
            } else if (val < 1) {
              return `${val.toFixed(2)} ${this.series.unit}`;
            } else {
              return `${Math.floor(val)} ${this.series.unit}`;
            }
          },
        },
        title: {
          text: this.$t(`meter.units.${this.series.unit}`).toString(),
        },
      },
      tooltip: {
        shared: false,
        intersect: true,
      },
    };
  }



}
